import {BooleanRequirement} from '@yandex-delivery/api/model/order'
import {Slot, Switch, Text, Trail, Typography} from '@yandex-delivery/blocks'
import React from 'react'

import {Controller, useFormContext} from '../../externalPackage'
import {classes} from './SwitchRequirement.classes'

export type SwitchRequirementProps<T> = {
  name: string
  requirement: BooleanRequirement<T>
  onChange?: (value: T) => void
}

export function SwitchRequirement<T = boolean>({
  name,
  requirement,
  onChange,
}: SwitchRequirementProps<T>): React.ReactElement {
  const {control} = useFormContext()
  const {left = true, right = false} = requirement

  return (
    <Controller
      control={control}
      defaultValue={requirement.defaultValue}
      name={name}
      render={({field, fieldState}) => {
        return (
          <Slot size="l">
            <Text className={classes.body}>
              <Typography thickness="regular" variant="body2">
                {requirement.title}
              </Typography>
              {requirement.description && (
                <Typography color="minor" variant="caption1">
                  {requirement.description}
                </Typography>
              )}
            </Text>
            <Trail>
              <Switch
                error={fieldState.invalid}
                name={name}
                on={field.value === left}
                onChange={function _onChange(on) {
                  const value = on ? left : right

                  field.onChange(value)
                  onChange?.(
                    // видимо не умею правильно работать с дженериками
                    // @ts-expect-error 'T' could be instantiated with an arbitrary type which could be unrelated to 'boolean | T'.
                    value,
                  )
                }}
                size="m"
              />
            </Trail>
          </Slot>
        )
      }}
      rules={{
        required: requirement.required,
      }}
    />
  )
}
